// MCIP-14 — pure logic for the "failures not in any signal" section, so the
// wording (and its honesty) is testable without a DOM. The API's `unaccounted`
// object is: { count, detail: 'exact'|'approximate', sample: [{ failure_id,
// test_name, failure_category }] }.

/** Headline: quiet and factual — a reconciliation, not an alarm. */
export function unaccountedLabel(unaccounted) {
  const n = unaccounted?.count || 0;
  if (n <= 0) return null;
  return n === 1
    ? "1 failure in this run isn't in any signal below"
    : `${n} failures in this run aren't in any signal below`;
}

/**
 * The honest footnote. Approximate counts come from the run's failed total —
 * those failures were never harvested into signals, so they can be counted but
 * not named. `hidden` = counted failures beyond the named sample.
 */
export function unaccountedNote(unaccounted) {
  if (!unaccounted || !unaccounted.count) return null;
  const named = unaccounted.sample?.length || 0;
  const hidden = unaccounted.count - named;
  if (unaccounted.detail === 'approximate') {
    return named === 0
      ? 'Counted from the run totals — these failures were not harvested into signals, so they cannot be named here.'
      : `${hidden} of these were not harvested into signals, so they can be counted but not named.`;
  }
  return hidden > 0 ? `Showing ${named} of ${unaccounted.count}.` : null;
}

/** DATA_SETUP → "Data setup" — chip text, not a scream. */
export function categoryLabel(category) {
  if (!category) return null;
  const words = String(category).toLowerCase().split('_').join(' ');
  return words.charAt(0).toUpperCase() + words.slice(1);
}
